module.exports = __webpack_public_path__ + "img/Puente_Istobal_MWASH3PRO_Alto_Blanco-default-front.a7198c9e.jpg";